// EN-4518: single source of truth for whether the ID capture step belongs in the
// flow. Used by every navigation site and by the progress bar so the step count
// and the routing can never disagree.
//
// idValidationSkip is only ever true when checkIdValidationExpiry explicitly
// returned isIdValidationExpired === false. Every other path — not yet checked,
// request failed, malformed response, validity disabled — leaves it false and
// the visitor scans their ID, which is the safe direction.
export const shouldShowIdCapture = (
  isIdCapturingFlag: boolean | undefined | null,
  idValidationSkip: boolean | undefined | null,
): boolean => !!isIdCapturingFlag && idValidationSkip !== true;

interface IdValidationVisitorType {
  idValidation?: boolean | null;
}

// Whether the visitor type has ID validation on. Only then does the ID step use
// the passport / barcode scanning flow. Otherwise the ID step is the production
// one, with the photos taken by countdown and sent on Continue: "ID capture only",
// and the offender check without ID validation (the backend still reads the photo
// and runs the offender check; the Valid / Invalid pop-ups and Retry work as in
// production).
// Only the visitor type's setting is read here. The org's entitlements are left to
// the backend, as in production, where the frontend checks neither.
export const isIdValidationEnabled = (
  visitorType: IdValidationVisitorType | null | undefined,
): boolean => !!visitorType?.idValidation;
